// FILEPATH: /C:/Open_market/formulario_contacto_empresas/src/__tests__/digitalData.test.js

const digitalData = require("../digitalData");

describe("digitalData", () => {
  it("should have the correct structure", () => {
    expect(digitalData).toMatchObject({
      versionDL: expect.any(String),
      pageInstanceID: expect.any(String),
      page: expect.objectContaining({
        pageInfo: expect.objectContaining({
          pageName: expect.any(String),
          pageIntent: expect.any(String),
          pageSegment: expect.any(String),
          sysEnv: expect.any(String),
          version: expect.any(String),
          channel: expect.any(String),
          language: expect.any(String),
          geoRegion: expect.any(String),
          level1: expect.any(String),
          level2: expect.any(String),
          level3: expect.any(String),
          level4: expect.any(String),
          level5: expect.any(String),
          level6: expect.any(String),
          level7: expect.any(String),
          level8: expect.any(String),
          level9: expect.any(String),
          level10: expect.any(String),
          area: expect.any(String),
          server: expect.any(String),
          businessUnit: expect.any(String),
          siteAppName: expect.any(String),
          projectName: expect.any(String),
          errorPage: expect.any(String)
        }),
        pageActivity: expect.objectContaining({
          search: expect.objectContaining({
            onSiteSearchResults: expect.any(String),
            onSiteSearchTerm: expect.any(String),
            onSiteSearchEnterTerm: expect.any(String)
          }),
          link: expect.objectContaining({
            name: expect.any(String),
            url: expect.any(String),
            ext: expect.any(String),
            aux1: expect.any(String),
            aux2: expect.any(String),
            aux3: expect.any(String)
          }),
          video: expect.objectContaining({
            nameOfVideoDisplayed: expect.any(String)
          }),
          audio: expect.objectContaining({
            nameOfPodcastDisplayed: expect.any(String)
          }),
          loginType: expect.any(String)
        })
      }),
      optimization: expect.objectContaining({
        attributes: expect.any(Array),
        event: expect.objectContaining({
          eventName: expect.any(String),
          optimizationEvent: expect.any(String)
        })
      }),
      internalCampaign: expect.objectContaining({
        attributes: expect.any(Array),
        event: expect.objectContaining({
          eventInfo: expect.objectContaining({
            eventName: expect.any(String),
            siteActionName: expect.any(String)
          })
        })
      }),
      user: expect.objectContaining({
        device: expect.objectContaining({
          userAgent: expect.any(String),
          mobile: expect.any(String),
          root: expect.any(String)
        }),
        userState: expect.any(String),
        profileID: expect.any(String),
        userID: expect.any(String),
        prospectID: expect.any(String),
        segment: expect.objectContaining({
          global: expect.any(String),
          profile: expect.any(String)
        }),
        gender: expect.any(String),
        country: expect.any(String),
        state: expect.any(String),
        age: expect.any(String),
        civilStatus: expect.any(String),
        educationLevel: expect.any(String),
        jobType: expect.any(String)
      }),
      application: expect.objectContaining({
        transactionID: expect.any(String),
        application: expect.objectContaining({
          type: expect.any(String),
          name: expect.any(String)
        }),
        fulfillmentModel: expect.any(String),
        typology: expect.any(String),
        programTypeHired: expect.any(String),
        offer: expect.any(String),
        operationNumber: expect.any(String),
        process: expect.any(String),
        step: expect.any(String),
        interactionLevel: expect.any(String),
        isQualifiedVisits: expect.any(Boolean),
        state: expect.any(String),
        errorType: expect.any(String),
        earnings: expect.any(String),
        expenses: expect.any(String),
        customFields: expect.any(String),
        globalApplication: expect.any(String)
      }),
      products: expect.objectContaining({
        attributes: expect.any(Array),
        productPortfolio: expect.any(Array)
      })
    });
  });
});
